import { useState } from "react"
import './toggle.css'
export const ToggleSwitch = (props) => {
    return (
        <div id="userMagnagement" >
            <label className='toggle-label'>
                <input className='toggle-checkbox' readOnly type="checkbox" checked={(props.data.isactive == 1) ? true : false} onClick={(e) => { props.toggleStatus(props.data) }} />
                <span className='toggle-span' >{(props.data.isactive == 1) ? <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Active</> : <>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;In-Active</>}</span>
            </label>
        </div>
    )
}
